/**
 * Classe base para todos os fields.
 * @author: Adalto Junior
 * Date: 20/09/13
 * Time: 11:47
 */


Monet.UI = Monet.UI || {};
Monet.UI.Fields = Monet.UI.Fields || {};

Monet.UI.Fields.Checkbox = (function () {

    function Checkbox () {

        Monet.UI.Fields.Base.apply (this, arguments);

        this.createBaseStructure ();

        this.input = null;
        this.value = false;

        var baseElement = null;

        this.createElement = function () {
            if(!baseElement){
                this.input = document.createElement ('input');

                this.input.type = 'checkbox';
                this.input.className = 'checkBoxField';

                baseElement = this.input;

                this.rootEl.insertBefore(this.input, this.label);

                if (this.meta && this.meta.fieldWarning) {
                    this.fieldWarning = document.createElement('div');
                    this.fieldWarning.className = 'fieldWarning';
                    this.fieldWarning.innerHTML = `<i class="fa fa-info-circle"></i> ${Monet.I18n.getResourcesByKey(this.meta.fieldWarning)}`;
                    this.rootEl.appendChild(this.fieldWarning);
                }
            }
        };

        this.setChecked = function (checked) {
            this.input.checked = checked;
        };

        this.render = function () {

            this.createElement();
            this.setInputValue();
            return this.rootEl;

        };
    
        this.setInputName = function (name) {
            this.name = name;
        
            if (this.input && name) {
                this.input.name = name;
                this.input.id = name;
            }
            
            this.label.setAttribute("for", name);
        
        };

        this.getValue = function () {
            if(this.input){
                this.value = this.input.checked;
            }
            return this.value;
        };

        this.setValue = function (value) {

            if (typeof value !== "boolean") {
                value = value === 'false'? false: Boolean(value);
            }

            this.value = value;
            
            this.setInputValue();
        };

        this.setInputValue = function () {

            if(this.input) {
                this.input.checked = this.value;
                this.afterCheckValue && this.afterCheckValue();
            }

        };

        this.clear = function () {
            this.setChecked(false);
        };

        this.setDefaultValue = function (defaultValue) {
            let value = defaultValue;

            if (typeof value !== "boolean") {
              value = value === 'false'? false: Boolean(value);
            }

            this.value = value;
            this.setInputValue();
        };

        this.addClickEventListener = (listenerFn) => {
            this.input.addEventListener('change', listenerFn);
        }
    }

    return Checkbox;

}());